import { React } from 'react';
import Heart from '../../Media/heart.svg';
import Plays from '../../Media/plays.svg';
import Comment from '../../Media/comment.svg';

import '../../components/Styles/profile.css';
// import {decode as base64_decode, encode as base64_encode} from 'base-64';
function LoadedFeed(props) {
  const responseObj = props.responseObj;
  console.log(
    '🚀 ~ file: LoadedFeed.jsx ~ line 10 ~ LoadedFeed ~ responseObj',
    responseObj,
  );
  // let encoded = base64_encode(responseObj.profile_pic_url);

  // If no such account found
  if (responseObj.message) {
    return (
      <div className="error-page">
        <h1>No such account found !</h1>
        <p>{responseObj.message}</p>
      </div>
    );
  }
  const storyArray = responseObj.feed.data;

  if (!storyArray) {
    return (
      <>
        <header className="user-info">
          <img
            src={responseObj.profile_pic_url}
            className="profile-picture"
            alt="Profile"
          />
          <div className="right-section">
            <h3>{responseObj.username}</h3>
            <p>{responseObj.full_name}</p>
          </div>
        </header>
        <div className="error-page">
          <h1>No profile Found</h1>
          <p>User has Private Profile</p>
        </div>
      </>
    );
  }

  const handleDownload = async (e, username, index) => {
    const response = await fetch(
      `https://instagram-bulk-profile-scrapper.p.rapidapi.com/clients/api/ig/ig_profile?ig=${username}&response_type=feeds&corsEnabled=false`,
      {
        method: 'GET',
        headers: {
          'X-RapidAPI-Key':
            'ddfbf48ca6mshaf024b0c7c6cc6cp165b80jsn31fda4813286',
          'X-RapidAPI-Host': 'instagram-bulk-profile-scrapper.p.rapidapi.com',
        },
      },
    );
    const data = await response.json();

    window.open(
      data[0].feed.data[index].image_versions2.candidates[4].url,
      '_blank',
    );
  };
  const handleDownloadProfilePhoto = async (e, username) => {
    const response = await fetch(
      `https://instagram-bulk-profile-scrapper.p.rapidapi.com/clients/api/ig/ig_profile?ig=${username}&response_type=feeds&corsEnabled=false`,
      {
        method: 'GET',
        headers: {
          'X-RapidAPI-Key':
            'ddfbf48ca6mshaf024b0c7c6cc6cp165b80jsn31fda4813286',
          'X-RapidAPI-Host': 'instagram-bulk-profile-scrapper.p.rapidapi.com',
        },
      },
    );
    const data = await response.json();
    console.log(
      '🚀 ~ file: LoadedFeed.jsx ~ line 81 ~ handleDownloadProfilePhoto ~ data',
      data,
    );

    window.open(data[0].profile_pic_url_hd, '_blank');
  };

  function convertToInternationalCurrencySystem(labelValue) {
    // Nine Zeroes for Billions
    return Math.abs(Number(labelValue)) >= 1.0e9
      ? (Math.abs(Number(labelValue)) / 1.0e9).toFixed(2) + 'B'
      : // Six Zeroes for Millions
      Math.abs(Number(labelValue)) >= 1.0e6
      ? (Math.abs(Number(labelValue)) / 1.0e6).toFixed(2) + 'M'
      : // Three Zeroes for Thousands
      Math.abs(Number(labelValue)) >= 1.0e3
      ? (Math.abs(Number(labelValue)) / 1.0e3).toFixed(2) + 'K'
      : Math.abs(Number(labelValue));
  }

  return (
    <>
      <div className=" container">
        <div className=" container">
          <div
            style={{
              display: 'grid',
              justifyContent: 'center',
              textAlign: 'center',
            }}
          >
            <div>
              <img
                // src={`${responseObj.profile_pic_url}`}
                src={`${responseObj.profile_pic_url}`}
                // src={`https://scontent-lhr8-2.cdninstagram.com/v/t51.2885-19/277816207_319644756822997_3505369846053847606_n.jpg?stp=dst-jpg_s150x150&_nc_ht=scontent-lhr8-2.cdninstagram.com&_nc_cat=101&_nc_ohc=NEYnuUM30n8AX9LV9o8&edm=AEhMeswBAAAA&ccb=7-5&oh=00_AT_HPPqAlOQ-u_uBRJ_x_LE3f19_6OY3rJzoJ8Vqwj-2-w&oe=62B90A06&_nc_sid=7fba47`}
                className="profile-picture"
                alt="Profile"
                // crossOrigin="anonymous"
              />
            </div>
            <div
              onClick={(e) =>
                handleDownloadProfilePhoto(e, responseObj.username)
              }
              className="buttonDownload-photo"
            >
              <h6>Download</h6>
            </div>
          </div>

          <section className="profile-counts">
            <div className="media-count">
              <h3>{responseObj.media_count}</h3>
              <p>Posts</p>
            </div>
            <div className="follower-count">
              <h3>
                {convertToInternationalCurrencySystem(
                  responseObj.follower_count,
                )}
              </h3>
              <p>Seguidores</p>
            </div>
            <div className="following-count">
              <h3>
                {convertToInternationalCurrencySystem(
                  responseObj.following_count,
                )}
              </h3>
              <p>Seguindo</p>
            </div>
          </section>
        </div>
      </div>
      <section className="user-intro container">
        <h3 className="username">Usuário : {responseObj.username}</h3>
        <p className="fullname">Nome : {responseObj.full_name}</p>
        <p className="bio">Bio : {responseObj.biography}</p>
      </section>

      <section className="story-list">
        {storyArray.map((element, index) => {
          if (element.media_type === 2) {
            return (
              <>
                <div className="story-item story-box">
                  <video className="story-item" key={index} controls>
                    <source
                      src={element.video_versions[0].url}
                      className="story-media"
                      type="video/webm"
                    ></source>
                  </video>

                  <div className="likes">
                    <div className="plays">
                      <a
                        href={`https://www.impulsionegram.com.br/comprar-visualizacoes-reels-instagram/?utm_source=ferramenta&utm_medium=seo&utm_campaign=views-reels-ferramentas`}
                        target="_blank"
                        className="flex"
                        rel="noreferrer"
                      >
                        <img
                          src={Plays}
                          className="nav-icons"
                          alt="search Story"
                        />
                        <p>
                          {convertToInternationalCurrencySystem(
                            element.view_count,
                          )}{' '}
                          visualizações
                        </p>
                      </a>
                    </div>
                    <br />
                    <div className="like-count">
                      <a
                        href={`https://www.impulsionegram.com.br/comprar-curtidas-instagram/?utm_source=ferramenta&utm_medium=seo&utm_campaign=likes-ferramentas`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={Heart}
                          className="nav-icons"
                          alt="search Story"
                        />
                        <p>
                          {convertToInternationalCurrencySystem(
                            element.like_count,
                          )}{' '}
                        </p>
                      </a>
                    </div>
                  </div>
                  <br />

                  <div
                    onClick={(e) =>
                      handleDownload(e, responseObj.username, index)
                    }
                    className="buttonDownload"
                  >
                    <h4>Download</h4>
                  </div>
                </div>
              </>
            );
          }
          if (element.media_type === 1) {
            return (
              <>
                <div className="story-item story-box container">
                  <img
                    src={element.image_versions2.candidates[4].url}
                    className="post-media"
                    alt="post media"
                  />
                  <div className="likes">
                    <div className="plays">
                      <a
                        href={`https://www.impulsionegram.com.br/comprar-comentarios-instagram/?utm_source=ferramenta&utm_medium=seo&utm_campaign=likes-ferramentas`}
                        target="_blank"
                        className="flex"
                        rel="noreferrer"
                      >
                        <img
                          src={Comment}
                          className="nav-icons"
                          alt="search Story"
                        />
                        <p>{element.comment_count} comentários</p>
                      </a>
                    </div>
                    <br />
                    <div className="like-count">
                      <a
                        href={`https://www.impulsionegram.com.br/comprar-curtidas-instagram/?utm_source=ferramenta&utm_medium=seo&utm_campaign=likes-ferramentas`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={Heart}
                          className="nav-icons"
                          alt="search Story"
                        />
                        <p>
                          {convertToInternationalCurrencySystem(
                            element.like_count,
                          )}{' '}
                          likes
                        </p>
                      </a>
                    </div>
                  </div>
                  <br />
                  <div
                    onClick={(e) =>
                      handleDownload(e, responseObj.username, index)
                    }
                    className="buttonDownload"
                  >
                    <h4>Download</h4>
                  </div>
                </div>
              </>
            );
          }
          if (element.media_type === 8) {
            return (
              <>
                <div className="story-item story-box">
                  <img
                    src={
                      element.carousel_media[0].image_versions2.candidates[0]
                        .url
                    }
                    className="post-media"
                    alt="post media"
                  />
                  <div className="likes">
                    <div className="plays">
                      <a
                        href={`https://www.impulsionegram.com.br/comprar-comentarios-instagram/?utm_source=ferramenta&utm_medium=seo&utm_campaign=likes-ferramentas`}
                        target="_blank"
                        className="flex"
                        rel="noreferrer"
                      >
                        <img
                          src={Comment}
                          className="nav-icons"
                          alt="search Story"
                        />

                        <p>
                          {' '}
                          {convertToInternationalCurrencySystem(
                            element.comment_count,
                          )}{' '}
                          comentários
                        </p>
                      </a>
                    </div>
                    <br />
                    <div className="like-count">
                      <a
                        href={`https://www.impulsionegram.com.br/comprar-curtidas-instagram/?utm_source=ferramenta&utm_medium=seo&utm_campaign=likes-ferramentas`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={Heart}
                          className="nav-icons"
                          alt="search Story"
                        />
                        <p>
                          {convertToInternationalCurrencySystem(
                            element.like_count,
                          )}{' '}
                          likes
                        </p>
                      </a>
                    </div>
                  </div>
                  <br />
                  <div
                    onClick={(e) =>
                      handleDownload(e, responseObj.username, index)
                    }
                    className="buttonDownload"
                  >
                    <h4>Download</h4>
                  </div>
                </div>
              </>
            );
          }
        })}
      </section>
    </>
  );
}

export default LoadedFeed;
